import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { CardModule } from 'primeng/card';
import { StateService } from '@uirouter/core';
import { PageLayoutComponent } from '@client/app/feature-modules/shared/components/page-layout/page-layout.component';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';


interface AdminCardItem {
    title: string;
    description: string;
    action: () => void;
    featureFlag?: string;
}

@Component({
    selector: 'mon-admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    standalone: true,
    imports: [
        TranslocoModule,
        CardModule,
        CommonModule,
        PageLayoutComponent,
    ],
    styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {

    adminCardItems: AdminCardItem[] = [];
    visibleCardItems: AdminCardItem[] = [];

    constructor (
        private readonly stateService: StateService,
        private readonly translocoService: TranslocoService,
        private readonly activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit (): void {
        this.adminCardItems = [
            {
                title: this.translocoService.translate('adminDashboard.card.user.title'),
                description: this.translocoService.translate('adminDashboard.card.user.description'),
                action: () => this.onUsersCardClick(),
            },
            {
                title: this.translocoService.translate('adminDashboard.card.scanExclusion.title'),
                description: this.translocoService.translate('adminDashboard.card.scanExclusion.description'),
                action: () => this.onScanExclusionsCardClick(),
                featureFlag: 'admin_source_code_excludes',
            },
            {
                title: this.translocoService.translate('adminDashboard.card.label.title'),
                description: this.translocoService.translate('adminDashboard.card.label.description'),
                action: () => this.onLabelsCardClick(),
                featureFlag: 'labels',
            },
        ];

        this.visibleCardItems = this.adminCardItems.filter(card => {
            if (card.featureFlag) {
                return this.activeFeatureService.isFeatureActive(card.featureFlag);
            }
            return true;
        });
    }

    onUsersCardClick (): void {
        this.stateService.go('base.customer.admin.add-user');
    }

    onScanExclusionsCardClick (): void {
        this.stateService.go('base.customer.admin.add-scan-exclusions');
    }

    onLabelsCardClick (): void {
        this.stateService.go('base.customer.admin.labels');
    }
}
